import React from 'react'
import { Grid, Typography, TextField, Button, Stack } from '@mui/material'

function NewsletterCard() {
  return (
    <Grid
      container
      style={{
        background: '#cc0600',
        minHeight: '200px',
        paddingBottom: '50px',
      }}
    >
      <Grid item xs={1} />
      <Grid
        item
        xs={10}
        container
        style={{
          marginTop: '30px',
          marginBotton: '30px',
        }}
      >
        <Grid item xs={12} sm={6}>
          <Typography variant='h5' style={{ color: '#fff', fontSize: '30px' }}>
            Sign up for Newsletter
          </Typography>
          <br />
          <Typography variant='body2' style={{ color: '#fff' }}>
            Get Email about information our latest app
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack direction='row'>
            <TextField
              style={{ background: '#fff', width: '70%' }}
              size='small'
            />
            <Button variant='contained' sx={{ background: '#228B22' }}>
              Sign Up
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  )
}

export default NewsletterCard
